import * as model from "@/model/prd/productionExecution/smelting/ElectrodeDischargePlan";
import { newEntityStoreHelper } from "@/store/common/entityModule";
import router from "@/router";
import _ from 'lodash';

function newFilter(paginationFilter = {}) {
  var filter = Object.assign({}, paginationFilter, model.filter)
  return filter;
}

const baseStore = newEntityStoreHelper(() => new model.ElectrodeDischargePlan(), newFilter).buildStore();

function date2str(date) {
  let year = date.getFullYear();
  let month = date.getMonth();
  let d = date.getDate();
  return `${year}-${month + 1}-${d}`;
}

const baseUrl = process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd";

const electrodeDischargePlanStore = {
  namespaced: true,
  state: {
    baseModuleUrl: baseUrl,
    currentElectrodeDischargePlan: {},
  },
  mutations: {
    setCurrentElectrodeDischargePlan(state, data) {
      state.currentElectrodeDischargePlan = data;
    },
  },
  actions: {
    jumpToEdit(context, item) {
      context.commit("electrodeDischargePlan/setCurrentElectrodeDischargePlan", item, {
        root: true
      });
      router.push({
        name: "electrodeDischargePlanEdit"
      });
    },
    findAll(context) {
      return context.dispatch('api/post', {
        url: baseUrl + '/electrodeDischargePlan/findAll',
      }, {
          root: true,
        });
    },
    findPage(context, { index, size }) {
      const data = new FormData();
      data.append('page', index)
      data.append('size', size)

      return context.dispatch('api/post', {
        url: baseUrl + '/electrodeDischargePlan/findPage',
        data,
      }, {
          root: true,
        });
    },
    deleteById(context, id) {
      const data = new FormData();
      data.append('id', id)
      return context.dispatch('api/post', {
        url: baseUrl + '/electrodeDischargePlan/delete',
        data,
      }, {
          root: true,
        });
    },
    getLength(context) {
      return context.dispatch('api/post', {
        url: baseUrl + '/electrodeDischargePlan/getLength',
      }, { root: true })
    },
    saveCurrentElectrodeDischargePlan(context) {
      return context.dispatch('saveElectrodeDischargePlan', context.state.currentElectrodeDischargePlan);
    },
    saveElectrodeDischargePlan(context, electrodeDischargePlan) {
      let data = new FormData();
      let id = electrodeDischargePlan.id > 0 ? electrodeDischargePlan.id : -1;
      data.append('id', id);
      data.append('date', date2str(electrodeDischargePlan.date));
      data.append('furnaceNumber', electrodeDischargePlan.furnaceNumber);
      data.append('shift', electrodeDischargePlan.shift);
      data.append('powerCost', electrodeDischargePlan.powerCost);
      data.append('tubeFeed1', electrodeDischargePlan.tubeFeed1);
      data.append('tubeFeed2', electrodeDischargePlan.tubeFeed2);
      data.append('tubeFeed3', electrodeDischargePlan.tubeFeed3);
      data.append('electrodeDiff1', electrodeDischargePlan.electrodeDiff1);
      data.append('electrodeDischarge1', electrodeDischargePlan.electrodeDischarge1);
      data.append('electrodeDiff2', electrodeDischargePlan.electrodeDiff2);
      data.append('electrodeDischarge2', electrodeDischargePlan.electrodeDischarge2);
      data.append('electrodeDiff3', electrodeDischargePlan.electrodeDiff3);
      data.append('electrodeDischarge3', electrodeDischargePlan.electrodeDischarge3);
      data.append('bottomTemp12HStart', electrodeDischargePlan.bottomTemp12HStart);
      data.append('bottomTemp12HEnd', electrodeDischargePlan.bottomTemp12HEnd);
      data.append('bottomTemp12HDiff', electrodeDischargePlan.bottomTemp12HDiff);
      data.append('bottomTemp22HStart', electrodeDischargePlan.bottomTemp22HStart);
      data.append('bottomTemp22HEnd', electrodeDischargePlan.bottomTemp22HEnd);
      data.append('bottomTemp22HDiff', electrodeDischargePlan.bottomTemp22HDiff);
      data.append('bottomTemp32HStart', electrodeDischargePlan.bottomTemp32HStart);
      data.append('bottomTemp32HEnd', electrodeDischargePlan.bottomTemp32HEnd);
      data.append('bottomTemp32HDiff', electrodeDischargePlan.bottomTemp32HDiff);
      data.append('envTempStart', electrodeDischargePlan.envTempStart);
      data.append('envTempEnd', electrodeDischargePlan.envTempEnd);
      data.append('envTempDiff', electrodeDischargePlan.envTempDiff);
      data.append('coverTemp414Start', electrodeDischargePlan.coverTemp414Start);
      data.append('coverTemp414End', electrodeDischargePlan.coverTemp414End);
      data.append('coverTemp414Diff', electrodeDischargePlan.coverTemp414Diff);
      data.append('coverTemp424Start', electrodeDischargePlan.coverTemp424Start);
      data.append('coverTemp424End', electrodeDischargePlan.coverTemp424End);
      data.append('coverTemp424Diff', electrodeDischargePlan.coverTemp424Diff);
      data.append('coverTemp434Start', electrodeDischargePlan.coverTemp434Start);
      data.append('coverTemp434End', electrodeDischargePlan.coverTemp434End);
      data.append('coverTemp434Diff', electrodeDischargePlan.coverTemp434Diff);
      data.append('tapholeTemp150HStart', electrodeDischargePlan.tapholeTemp150HStart);
      data.append('tapholeTemp150HEnd', electrodeDischargePlan.tapholeTemp150HEnd);
      data.append('tapholeTemp150HDiff', electrodeDischargePlan.tapholeTemp150HDiff);
      data.append('tapholeTemp152HStart', electrodeDischargePlan.tapholeTemp152HStart);
      data.append('tapholeTemp152HEnd', electrodeDischargePlan.tapholeTemp152HEnd);
      data.append('tapholeTemp152HDiff', electrodeDischargePlan.tapholeTemp152HDiff);
      data.append('tapholeTemp153HStart', electrodeDischargePlan.tapholeTemp153HStart);
      data.append('tapholeTemp153HEnd', electrodeDischargePlan.tapholeTemp153HEnd);
      data.append('tapholeTemp153HDiff', electrodeDischargePlan.tapholeTemp153HDiff);
      data.append('tapholeTemp155HStart', electrodeDischargePlan.tapholeTemp155HStart);
      data.append('tapholeTemp155HEnd', electrodeDischargePlan.tapholeTemp155HEnd);
      data.append('tapholeTemp155HDiff', electrodeDischargePlan.tapholeTemp155HDiff);
      data.append('slagTemp250', electrodeDischargePlan.slagTemp250);
      data.append('slagTemp251', electrodeDischargePlan.slagTemp251);
      data.append('slagTemp252', electrodeDischargePlan.slagTemp252);
      data.append('slagTemp253', electrodeDischargePlan.slagTemp253);
      data.append('slagTemp254', electrodeDischargePlan.slagTemp254);
      data.append('slagTemp255', electrodeDischargePlan.slagTemp255);
      data.append('ironTemp131Start', electrodeDischargePlan.ironTemp131Start);
      data.append('ironTemp131End', electrodeDischargePlan.ironTemp131End);
      data.append('ironTemp131Diff', electrodeDischargePlan.ironTemp131Diff);
      data.append('ironTemp132Start', electrodeDischargePlan.ironTemp132Start);
      data.append('ironTemp132End', electrodeDischargePlan.ironTemp132End);
      data.append('ironTemp132Diff', electrodeDischargePlan.ironTemp132Diff);
      data.append('ironTemp133Start', electrodeDischargePlan.ironTemp133Start);
      data.append('ironTemp133End', electrodeDischargePlan.ironTemp133End);
      data.append('ironTemp133Diff', electrodeDischargePlan.ironTemp133Diff);
      data.append('drillDepth1', electrodeDischargePlan.drillDepth1);
      data.append('oxygenTube1', electrodeDischargePlan.oxygenTube1);
      data.append('slagStatus1', electrodeDischargePlan.slagStatus1);
      data.append('drillDepth2', electrodeDischargePlan.drillDepth2);
      data.append('oxygenTube2', electrodeDischargePlan.oxygenTube2);
      data.append('slagStatus2', electrodeDischargePlan.slagStatus2);
      data.append('drillDepth3', electrodeDischargePlan.drillDepth3);
      data.append('oxygenTube3', electrodeDischargePlan.oxygenTube3);
      data.append('slagStatus3', electrodeDischargePlan.slagStatus3);
      data.append('drillDepth4', electrodeDischargePlan.drillDepth4);
      data.append('oxygenTube4', electrodeDischargePlan.oxygenTube4);
      data.append('slagStatus4', electrodeDischargePlan.slagStatus4);
      data.append('drillDepth5', electrodeDischargePlan.drillDepth5);
      data.append('oxygenTube5', electrodeDischargePlan.oxygenTube5);
      data.append('slagStatus5', electrodeDischargePlan.slagStatus5);
      data.append('totalElectrodeDropStart', electrodeDischargePlan.totalElectrodeDropStart);
      data.append('totalElectrodeDropEnd', electrodeDischargePlan.totalElectrodeDropEnd);
      data.append('electrodeDrop1', electrodeDischargePlan.electrodeDrop1);
      data.append('electrodeDrop2', electrodeDischargePlan.electrodeDrop2);
      data.append('electrodeDrop3', electrodeDischargePlan.electrodeDrop3);
      data.append('preShiftCurrent1', electrodeDischargePlan.preShiftCurrent1);
      data.append('preShiftCurrentIndex1', electrodeDischargePlan.preShiftCurrentIndex1);
      data.append('preShiftCurrent2', electrodeDischargePlan.preShiftCurrent2);
      data.append('preShiftCurrentIndex2', electrodeDischargePlan.preShiftCurrentIndex2);
      data.append('preShiftCurrent3', electrodeDischargePlan.preShiftCurrent3);
      data.append('preShiftCurrentIndex3', electrodeDischargePlan.preShiftCurrentIndex3);
      data.append('transformerVoltageIndex1', electrodeDischargePlan.transformerVoltageIndex1);
      data.append('transformerVoltageIndex2', electrodeDischargePlan.transformerVoltageIndex2);
      data.append('transformerVoltageIndex3', electrodeDischargePlan.transformerVoltageIndex3);
      return context.dispatch('api/post', {
        url: baseUrl + '/electrodeDischargePlan',
        data,
      }, {
          root: true,
        })
    }
  }
}

export default _.defaultsDeep(electrodeDischargePlanStore, baseStore); // 合并 teamShiftStore 和 baseStore (冲突时选前者)